import styled from 'styled-components'
import ripple from '../../../styles/animations/ripple'

export const Role = {
  Container: styled.div`
    ${ripple}
    cursor: pointer;
  `,
  Menu: styled.div`
    gap: 8px;
    display: flex;
    flex-direction: column;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    padding: 10px;
  `,
  Item: styled.div`
    ${ripple}
    cursor: pointer;
    font-size: 13.5px;
    font-weight: 500;
    color: #1e293b;
    padding: 6px 10px;
    border-radius: 6px;
    transition: all 0.15s ease;

    &:hover {
      background-color: #f1f5f9;
      color: #0284c7;
    }
  `,
}

export const NamePhoto = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  text-transform: capitalize;
  gap: 15px;
  img {
    width: 35px;
    border-radius: 100px;
    height: 35px;
  }
`
